export const LOAD_REQUESTED = "PROGRESS_BUTTON/LOAD_REQUESTED";
export const LOAD_SUCCESS = "PROGRESS_BUTTON/LOAD_SUCCESS";
export const LOAD_FAIL = "PROGRESS_BUTTON/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadNextDocumentButton = data => ({ type: LOAD_REQUESTED, data });
export const successLoadNextDocumentButton = data => ({ type: LOAD_SUCCESS, data });
export const failLoadNextDocumentButton = data => ({ type: LOAD_FAIL, data });
